import list from '../data/list';

export default {
    data() {
        return {
            list,
        }
    },

    props: {
        data: {
            type: Object,
            default() {
                return {}
            }
        }
    },

    created() {

    },

    methods: {
        openPage(item,cItem) {
            if(item.key === 'article') {
                // this.$router.push({
                //     name: 'news-detail',
                //     query: {
                //         id: cItem.id
                //     }
                // })
                window.open(this._link + 'news/detail?id=' + cItem.id)
            }else if(item.key === "activity") {
                window.open(this._link + 'active/detail?id=' + cItem.id + '&type=' + cItem.type)
                // this.$router.push({
                //     name: 'active-detail',
                //     query: {
                //         type: cItem.type,
                //         id: cItem.id,
                //         // data: this.$Encrypt(JSON.stringify(cItem))
                //     }
                // })
            }else if(item.key === "topic"){
                window.open(this._link + 'topic/detail?id=' + cItem.id)
                // this.$router.push({
                //     name: 'topic-detail',
                //     query: {
                //         id: this.data.id
                //         // data: this.$Encrypt(JSON.stringify(cItem))
                //     }
                // })
            }
        }
    }
}
